var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsbDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1344,
    height: 1345,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1528 -565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M590.048 811.316C549.314 811.316 516.292 844.337 516.292 885.072 516.292 925.808 549.314 958.828 590.048 958.828L1180.1 958.828C1220.83 958.828 1253.85 925.808 1253.85 885.072 1253.85 844.337 1220.83 811.316 1180.1 811.316L590.048 811.316Z",
    stroke: "#000000",
    strokeWidth: 0.0177014,
    transform: "matrix(1 0 0 1.00011 1314.63 350.84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.268 885.072C221.268 681.401 386.377 516.292 590.048 516.292L1180.1 516.292C1383.77 516.292 1548.88 681.401 1548.88 885.072 1548.88 1088.74 1383.77 1253.85 1180.1 1253.85L590.048 1253.85C386.377 1253.85 221.268 1088.74 221.268 885.072ZM590.048 663.804 1180.1 663.804C1302.3 663.804 1401.36 762.866 1401.36 885.072 1401.36 1007.28 1302.3 1106.34 1180.1 1106.34L590.048 1106.34C467.846 1106.34 368.78 1007.28 368.78 885.072 368.78 762.866 467.846 663.804 590.048 663.804Z",
    stroke: "#000000",
    strokeWidth: 0.0177014,
    fillRule: "evenodd",
    transform: "matrix(1 0 0 1.00011 1314.63 350.84)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbDark);
export default __webpack_public_path__ + "static/media/usb_dark.b0aa7c1d8042b8c2287dbf1f944e56dc.svg";
export { ForwardRef as ReactComponent };